import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "rentComponent" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressSelectComponent = _resolveComponent("AddressSelectComponent")!
  const _component_DatepickerComponent = _resolveComponent("DatepickerComponent")!
  const _component_TimePickerComponent = _resolveComponent("TimePickerComponent")!
  const _component_PassengersComponent = _resolveComponent("PassengersComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.withDriver)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_AddressSelectComponent, {
            placeHolder: _ctx.$t('drive_from'),
            flag: false,
            rent: true,
            id: 'pickup-location',
            "location-store": _ctx.store.state.orderTrueDriver.pickup,
            "is-valid": _ctx.store.state.orderTrueDriver.messages.validLocation.state,
            message: _ctx.store.state.orderTrueDriver.messages.validLocation.message,
            onGetAddress: _ctx.getAddress
          }, null, 8, ["placeHolder", "location-store", "is-valid", "message", "onGetAddress"]),
          _createVNode(_component_DatepickerComponent, {
            datepickerTranslation: _ctx.$t('departure'),
            "date-store": _ctx.store.state.orderTrueDriver.arrivalDate,
            "default-date": _ctx.tomorrow,
            "is-valid": _ctx.store.state.orderTrueDriver.messages.validDate.state,
            message: _ctx.store.state.orderTrueDriver.messages.validDate.message,
            onGetDate: _ctx.getDate
          }, null, 8, ["datepickerTranslation", "date-store", "default-date", "is-valid", "message", "onGetDate"]),
          _createVNode(_component_TimePickerComponent, {
            modalTranslation: _ctx.$t('choose_pickup_time'),
            "time-store": _ctx.store.state.orderTrueDriver.arrivalTime,
            onGetTime: _ctx.getTime
          }, null, 8, ["modalTranslation", "time-store", "onGetTime"]),
          _createVNode(_component_PassengersComponent, {
            "passengers-store": _ctx.store.state.orderTrueDriver.passengerCount,
            onGetPassengers: _ctx.getPassengers
          }, null, 8, ["passengers-store", "onGetPassengers"]),
          (_ctx.currRouteName === _ctx.routesConst.HOME)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass({ 'disabled-confirmButton': _ctx.disabled, 'confirmButton': !_ctx.disabled }),
                disabled: _ctx.disabled,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, [
                _createVNode(_component_router_link, { to: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
                  ]),
                  _: 1
                })
              ], 10, _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.currRouteName === _ctx.routesConst.SERVICES_IFRAME)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass({ 'disabled-confirmButton': _ctx.disabled, 'confirmButton': !_ctx.disabled }),
                disabled: _ctx.disabled,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit($event, _ctx.routesConst.SERVICES_IFRAME)))
              }, [
                _createVNode(_component_router_link, { to: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
                  ]),
                  _: 1
                })
              ], 10, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.withDriver)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_AddressSelectComponent, {
            id: "map-pickup-end-location",
            placeHolder: _ctx.$t('pickup_and_return'),
            flag: false,
            rent: true,
            "location-store": _ctx.store.state.orderFalseDriver.destination,
            "is-valid": _ctx.store.state.orderFalseDriver.messages.validLocation.state,
            message: _ctx.store.state.orderFalseDriver.messages.validLocation.message,
            onGetAddress: _ctx.getAddress
          }, null, 8, ["placeHolder", "location-store", "is-valid", "message", "onGetAddress"]),
          _createVNode(_component_DatepickerComponent, {
            datepickerTranslation: _ctx.$t('pick_up'),
            "pickup-date": true,
            "date-store": _ctx.store.state.orderFalseDriver.pickupDate,
            "default-date": _ctx.tomorrow,
            "is-valid": _ctx.store.state.orderFalseDriver.messages.validDate.state,
            message: _ctx.store.state.orderFalseDriver.messages.validDate.message,
            onGetDate: _ctx.getDate
          }, null, 8, ["datepickerTranslation", "date-store", "default-date", "is-valid", "message", "onGetDate"]),
          _createVNode(_component_TimePickerComponent, {
            modalTranslation: _ctx.$t('choose_pickup_time'),
            "pickup-time": true,
            "time-store": _ctx.store.state.orderFalseDriver.pickupTime,
            "is-valid": _ctx.store.state.orderFalseDriver.messages.validTime.state,
            message: _ctx.store.state.orderFalseDriver.messages.validTime.message,
            onGetTime: _ctx.getTime
          }, null, 8, ["modalTranslation", "time-store", "is-valid", "message", "onGetTime"]),
          _createVNode(_component_DatepickerComponent, {
            datepickerTranslation: _ctx.$t('return'),
            "pickup-date": false,
            "date-store": _ctx.store.state.orderFalseDriver.endDate,
            "default-date": _ctx.week,
            "is-valid": _ctx.store.state.orderFalseDriver.messages.validDate.state,
            message: _ctx.store.state.orderFalseDriver.messages.validDate.message,
            onGetDate: _ctx.getDate
          }, null, 8, ["datepickerTranslation", "date-store", "default-date", "is-valid", "message", "onGetDate"]),
          _createVNode(_component_TimePickerComponent, {
            modalTranslation: _ctx.$t('choose_return_time'),
            "pickup-time": false,
            "time-store": _ctx.store.state.orderFalseDriver.endTime,
            "is-valid": _ctx.store.state.orderFalseDriver.messages.validTime.state,
            message: _ctx.store.state.orderFalseDriver.messages.validTime.message,
            onGetTime: _ctx.getTime
          }, null, 8, ["modalTranslation", "time-store", "is-valid", "message", "onGetTime"]),
          _createVNode(_component_PassengersComponent, {
            "passengers-store": _ctx.store.state.orderFalseDriver.passengerCount,
            onGetPassengers: _ctx.getPassengers
          }, null, 8, ["passengers-store", "onGetPassengers"]),
          (_ctx.currRouteName === _ctx.routesConst.HOME)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass({ 'disabled-confirmButton': _ctx.disabled, 'confirmButton': !_ctx.disabled }),
                disabled: _ctx.disabled,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, [
                _createVNode(_component_router_link, { to: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
                  ]),
                  _: 1
                })
              ], 10, _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.currRouteName === _ctx.routesConst.CHOOSE_VEHICLE)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass({ 'disabled-confirmButton': _ctx.disabled, 'confirmButton': !_ctx.disabled }),
                disabled: _ctx.disabled,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmit($event, _ctx.routesConst.CHOOSE_VEHICLE)))
              }, [
                _createVNode(_component_router_link, { to: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('search')), 1)
                  ]),
                  _: 1
                })
              ], 10, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.currRouteName === _ctx.routesConst.SERVICES_IFRAME)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: _normalizeClass({ 'disabled-confirmButton': _ctx.disabled, 'confirmButton': !_ctx.disabled }),
                disabled: _ctx.disabled,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubmit($event, _ctx.routesConst.SERVICES_IFRAME)))
              }, [
                _createVNode(_component_router_link, { to: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('next')), 1)
                  ]),
                  _: 1
                })
              ], 10, _hoisted_8))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}